import { useCallback } from 'react';
import { emitWhenConnected } from '../socketHelpers';

export function useReportApi(socket) {
  const generateReportOnServer = useCallback(
    (interestingFavorites, callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      emitWhenConnected(socket, () => {
        socket.emit('generate_report', interestingFavorites, (response) => {
          if (callback) callback(response);
        });
      });
    },
    [socket]
  );

  return { generateReportOnServer };
}
